import React, {useState, useEffect} from 'react'
import './AllCollectionPage.scss'
import TopNavSubpage from "../../component/TopNav/TopNavSubpage";
import BottomNav from "../../component/BottomNav/BottomNav";
import CollectionsComponent from "../../component/Collections/CollectionsComponent";
import {fetchQuery} from "relay-runtime";
import environment from "../../Environment";
import AllCollectionsQuery from "../../queries/AllCollectionsQuery";
import Loading from "../../component/Loading";
import Skeleton from "react-loading-skeleton";

const AllCollectionPage = () => {
	const [collectionList, setCollectionList] = useState([]);
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		getAllCollections()
	}, []);

	const updateLoading = (action) => {
		setLoading(action)
	}
	const getAllCollections = () => {
		let variables = {}
		updateLoading(true);
		fetchQuery(environment, AllCollectionsQuery, variables)
			.toPromise()
			.then(response => {
				updateLoading(false);
				if (response.allCollections !== null && response.allCollections.edges.length > 0) {
					setCollectionList(response.allCollections.edges)
				} else {
					setCollectionList([])
				}
			}, err => {
				updateLoading(false);
				console.log(err);
				setCollectionList([])
			});
	}
	return (
		<Loading loading={loading}>
			<div className={"collection-page"}>
				<TopNavSubpage heading={"Your Groups"} wallet={true} notify={true}/>

				{
					loading ?
					<>
						<div className={'d-flex'}>
							<Skeleton style={{margin: "12px"}} count={2} height={"152px"}
							          width={"150px"}/>
						</div>
						<div className={'d-flex'}>
							<Skeleton style={{margin: "12px"}} count={2} height={"152px"}
							          width={"150px"}/>
						</div>
						<div className={'d-flex'}>
							<Skeleton style={{margin: "12px"}} count={2} height={"152px"}
							          width={"150px"}/>
						</div>
					</>

					:
						<div className={"collection-content "}>
							<CollectionsComponent collection_data={collectionList}/>
						</div>
				}
				<div className={"bottom-nav"}>
					<BottomNav/>
				</div>
			</div>
		</Loading>

	)
}

export default AllCollectionPage
